<template>
    <div
        class="mb-7 mt-2 rounded-xl border shadow-sm transition-all duration-300"
    >
        <div
            class="flex cursor-pointer items-center justify-between p-4"
            @click="isOpen = !isOpen"
        >
            <h3 class="font-semibold text-grind">{{ material.material }}</h3>
            <button
                class="h-11 w-11 rounded border border-grind px-2.5 py-1.5 text-grind transition hover:border-brew hover:bg-brew hover:text-white"
                :class="{
                    'bg-grind text-white': isOpen,
                }"
            >
                <Icon :name="isOpen ? 'minus' : 'plus'" class="text-xl" />
            </button>
        </div>
        <div v-if="isOpen" class="-mt-2">
            <div class="px-4 pb-8 text-brew md:flex md:items-center md:gap-6">
                <div v-if="setupGuide" class="flex cursor-pointer gap-x-2 py-1">
                    <Icon name="download-light" /><a
                        :href="setupGuide"
                        target="_blank"
                        class="underline"
                        >Setup Guide</a
                    >
                </div>
                <div
                    v-if="toleranceForm"
                    class="flex cursor-pointer gap-x-2 py-1"
                >
                    <Icon name="download-light" /><a
                        :href="toleranceForm"
                        target="_blank"
                        class="underline"
                        >Tolerance Form</a
                    >
                </div>
                <div class="flex hidden gap-x-2 py-1">
                    <Icon name="download-light" /><a href="#" class="underline"
                        >Disposal Logo</a
                    >
                </div>
            </div>
            <div
                class="grid grid-cols-[1fr_20%] border-b border-b-grind-800 px-6 pb-4"
            >
                <div
                    class="text-xs font-thin uppercase tracking-widest text-grind"
                >
                    Size
                </div>
                <div
                    v-if="hasTemplates"
                    class="text-xs font-thin uppercase tracking-widest text-grind"
                >
                    Template
                </div>
            </div>
            <div
                v-for="(size, index) in material.sizes"
                :key="index"
                class="text-md grid grid-cols-[1fr_20%] items-center border-b border-b-grind-400 px-6 py-4 last:rounded-b-xl last:border-b-0 odd:bg-gray-100 even:bg-transparent"
            >
                <div>{{ size.size }}</div>
                <div
                    v-if="hasTemplates && size.productId !== null"
                    class="flex gap-x-2 justify-self-center text-brew md:justify-self-start"
                >
                    <Icon name="download-light" class="text-2xl md:text-base" />
                    <a
                        :href="guideDownloadLink(size.productId)"
                        target="_blank"
                        class="underline"
                    >
                        <span class="hidden md:block">Download</span>
                    </a>
                </div>
                <div v-else>&nbsp;</div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import TemplateAlgoliaResult from '~/types/TemplateAlgoliaResult';

const props = defineProps<{
    material: TemplateAlgoliaResult;
    setupGuide: string;
    toleranceForm: string;
}>();

const isOpen = ref(false);
const hasTemplates = computed<string>(() => {
    return props.material.sizes.every((size) => size.productId !== null);
});

const guideDownloadLink = function (productId): string {
    return productId ? '/products/' + productId + '/download-template' : null;
};
</script>
